var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "header-container" },
    [
      _c("HeaderComponent", {
        ref: "headerComponent",
        attrs: {
          opacity: _vm.headerOpacity,
          headerType: _vm.headerType,
          authKey: _vm.authKey,
        },
        on: {
          goToLogin: _vm.goToLogin,
          goToChangePass: _vm.goToChangePass,
          menuToggle: _vm.menuToggle,
          logout: _vm.goToLogout,
          goToInvite: _vm.goToInvite,
          mobileMenuClose: _vm.menuClose,
        },
      }),
      _vm._v(" "),
      _c("MobileMenu", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.menu,
            expression: "menu",
          },
        ],
        attrs: { status: _vm.menu },
        on: {
          menuClose: _vm.menuClose,
          goToLogin: _vm.goToLogin,
          goToLogout: _vm.goToLogout,
          goToChangePass: _vm.goToChangePass,
          goToInvite: _vm.goToInvite,
        },
      }),
      _vm._v(" "),
      _vm.toInvite
        ? _c("InviteComponent", { on: { inviteClose: _vm.inviteClose } })
        : _vm._e(),
      _vm._v(" "),
      _vm.getLogin
        ? _c("LoginComponent", {
            on: {
              checkReward: _vm.checkReward,
              loginClose: _vm.loginClose,
              goToForgotPassword: _vm.goToForgotPassword,
              goToSignUp: _vm.goToSignUp,
              showNotification: _vm.showNotification,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.toSignUp
        ? _c("SignUpComponent", {
            on: {
              signUpClose: _vm.loginClose,
              backToLogin: _vm.backToLogin,
              welcome: _vm.signUpComplete,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.toForgotPassword
        ? _c("ForgotPasswordComponent", {
            on: {
              restoreComplete: _vm.restoreComplete,
              loginClose: _vm.loginClose,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.toChangePassword
        ? _c("ChangePasswordComponent", {
            on: {
              restoreComplete: _vm.restoreComplete,
              loginClose: _vm.loginClose,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.toComplete
        ? _c("CompleteComponent", {
            attrs: {
              title: _vm.title,
              subTitle: _vm.subTitle,
              buttonText: _vm.buttonText,
            },
            on: { loginClose: _vm.completeClose },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.toLogout
        ? _c("LogoutComponent", { on: { popupClose: _vm.logoutClose } })
        : _vm._e(),
      _vm._v(" "),
      _vm.notificationText
        ? _c("NotificationComponent", {
            staticClass: "is-error is-fixed",
            attrs: { text: _vm.notificationText },
            on: {
              closeToast: function ($event) {
                return _vm.closeToast()
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }